import {Component, input, output} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {Nouveaute} from '../../nouveaute.model';

@Component({
  selector: 'app-nouveautes-table',
  imports: [DatePipe, TranslateModule],
  templateUrl: './nouveautes-table.component.html',
  styleUrl: './nouveautes-table.component.scss',
})
export class NouveautesTableComponent {
  nouveautes = input.required<Nouveaute[]>();
  rowClick = output<string>();

  onRowClick(id: string): void {
    this.rowClick.emit(id);
  }
}
